__turbopack_context__.v({
  "Arrow": "dD8SpW_Arrow",
  "ArrowReverse": "dD8SpW_ArrowReverse",
  "Bg": "dD8SpW_Bg",
  "BlueGreen": "dD8SpW_BlueGreen",
  "Burger": "dD8SpW_Burger",
  "ContactText": "dD8SpW_ContactText",
  "ContactTitle": "dD8SpW_ContactTitle",
  "ContactWrap": "dD8SpW_ContactWrap",
  "Container": "dD8SpW_Container",
  "Dialog": "dD8SpW_Dialog",
  "DialogContainer": "dD8SpW_DialogContainer",
  "Hide": "dD8SpW_Hide",
  "Icon": "dD8SpW_Icon",
  "ImageContentInsights": "dD8SpW_ImageContentInsights",
  "ImageInsightsWrapper": "dD8SpW_ImageInsightsWrapper",
  "ImageLink": "dD8SpW_ImageLink",
  "ImageTextInsights": "dD8SpW_ImageTextInsights",
  "ImageTitleInsights": "dD8SpW_ImageTitleInsights",
  "IsOpen": "dD8SpW_IsOpen",
  "IsVisible": "dD8SpW_IsVisible",
  "IsZoomed": "dD8SpW_IsZoomed",
  "LanguageChevron": "dD8SpW_LanguageChevron",
  "LanguageDropdown": "dD8SpW_LanguageDropdown",
  "LanguageItem": "dD8SpW_LanguageItem",
  "LanguageList": "dD8SpW_LanguageList",
  "LanguageText": "dD8SpW_LanguageText",
  "LanguageWrapper": "dD8SpW_LanguageWrapper",
  "Languages": "dD8SpW_Languages",
  "LeftBlob": "dD8SpW_LeftBlob",
  "LinkContainer": "dD8SpW_LinkContainer",
  "Logo": "dD8SpW_Logo",
  "LogoLink": "dD8SpW_LogoLink",
  "LogoWrapper": "dD8SpW_LogoWrapper",
  "MegaMenu": "dD8SpW_MegaMenu",
  "MegaMenuButton": "dD8SpW_MegaMenuButton",
  "MegaMenuChildTitle": "dD8SpW_MegaMenuChildTitle",
  "MegaMenuContact": "dD8SpW_MegaMenuContact",
  "MegaMenuContainer": "dD8SpW_MegaMenuContainer",
  "MegaMenuGrandChildren": "dD8SpW_MegaMenuGrandChildren",
  "MegaMenuLink": "dD8SpW_MegaMenuLink",
  "MegaMenuLinkGrandChildTitle": "dD8SpW_MegaMenuLinkGrandChildTitle",
  "MegaMenuLinks": "dD8SpW_MegaMenuLinks",
  "MegaMenuMenuButton": "dD8SpW_MegaMenuMenuButton",
  "MegaNavWrap": "dD8SpW_MegaNavWrap",
  "MegaNavigationMobile": "dD8SpW_MegaNavigationMobile",
  "MenuText": "dD8SpW_MenuText",
  "NavHeader": "dD8SpW_NavHeader",
  "NavHeaderRight": "dD8SpW_NavHeaderRight",
  "NavigationMobile": "dD8SpW_NavigationMobile",
  "NavigationMobileLink": "dD8SpW_NavigationMobileLink",
  "Open": "dD8SpW_Open",
  "Overlay": "dD8SpW_Overlay",
  "PinkBlue": "dD8SpW_PinkBlue",
  "PinkOrange": "dD8SpW_PinkOrange",
  "PinkPurple": "dD8SpW_PinkPurple",
  "Root": "dD8SpW_Root",
  "Show": "dD8SpW_Show",
  "TopBlob": "dD8SpW_TopBlob",
});
